<template>
  <div class="holiday">
    <GridContainer padding>
      <Breadcrumb
        :items="breadcrumb"
        class="holiday__breadcrumb"
      />

      <Card
        v-bind="card"
        class="holiday__header"
      />
    </GridContainer>

    <GridContainer class="holiday__offers">
      <OfferTilesContainer
        v-if="offers && offers?.length > 0"
        :offers="offers"
      />
      <Paragraph
        v-else
        align="center"
      >
        Aktuell sind keine Produkt verfügbar!
      </Paragraph>
    </GridContainer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useLazyAsyncData } from '#imports';
import { Card, GridContainer, Paragraph } from '@i22-td-smarthome/component-library';

import fetchOffers, { type ListOffer } from '@/lib/goliath/offers';
import { getHeader } from '@/helpers/page-header-compositon';
import { Track } from '@/helpers/page-tracking';

import Breadcrumb from '@/components/breadcrumb.vue';
import OfferTilesContainer from '~/components/offer-tiles-container.vue';
import type { CardComponentProps } from '@i22-td-smarthome/component-library/dist/components/card/card.vue';

Track();
getHeader({
  title: ref('Urlaubs-Essentials entdecken'),
  description: ref(
    'Ob Powerbanks, Kopfhörer oder weitere Produkte: Ab in den Urlaub mit unseren Urlaubs-Essentials, die in keinem Koffer fehlen sollten. Jetzt entdecken!'
  ),
  isIndexed: ref(false),
});

const card: CardComponentProps = {
  heading: {
    tag: 'h1',
    size: 'lg',
    text: 'Ab in den Urlaub!',
  },
  imagePosition: 'right',
  text: 'Mit Urlaubs-Essentials, die in<br>keinem Koffer fehlen sollten!',
  imageBackground: {
    src: '/content/content-images/promotions/holiday/5832f6886aca6460a0e9b59e6ad8811a/shop-telekom-startseite-stage-urlaubsessentials-v2-s@2x.jpg',
    srcSm:
      '/content/content-images/promotions/holiday/36ba1d71b0f7f09554711dbcd006249f/shop-telekom-startseite-stage-urlaubsessentials-v2-m@2x.jpg',
    srcMd:
      '/content/content-images/promotions/holiday/38ca40a2bd146fc1f66e59b929c10af8/shop-telekom-startseite-stage-urlaubsessentials-v1b-l@2x.jpg',
    sizes: 'xs:100vw sm:100vw md:1280px lg:2560px',
  },
};

const { data: offers, error: errorData } = useLazyAsyncData(
  'easer-offers',
  (): Promise<ListOffer[]> =>
    fetchOffers({
      filter: {
        articleNumbers: [
          '0622356268240',

          '0194644297503',
          '0194644297510',
          '0194644297527',

          '4251483640870',

          '4251483603066',
          '4251483603097',

          '4048945048219',
          '4048945048141',
          '4048945048202',

          'PVP1L-B',
          'PVP1L-G',
          'PVP1L-GR',
          'PVP1L-P',
          'PVP1L-PI',
          'PVP1L-W',
          '4048945587626',
          '4048945587640',
          '4048945587657',
          '4048945587633',
          '4048945587664',
          '4068568997596',

          '4047443436795',
          '4068568918331',
          '0194644099091DT',

          'PITRPD',

          '6941812720974',

          '4255591500224',
          '4255591500286',
          '4066908785599',
          'TFBOOMSTERGO ',
          '4048945033796',

          '4048945034298',
          'TFMOTIVGO',

          '622356293365',

          '4255591500217',

          '4251483602120',
          '4251483602113',

          '4255591500187',
          '4255591500194',

          '8785267222311',

          '8018080454844',

          '8018080456817',

          '8018080471704',

          '3700764710814',

          '3700764704592',

          '4255591500835',

          '194644130886',

          '8718819375777',
          '8718819375760',

          'TFSUPREMEON',

          '0194644132118',

          '0194644207427',
          '0194644294250',
        ],
      },
      includeAggregations: false,
    }).then((response) => response?.entries || [])
);

// handle errors
if (errorData.value) {
  if (errorData.value.data?.message) {
    errorData.value.message = errorData.value.data.message;
  }

  console.error(errorData.value);

  // Show error page
  // throw useNuxtApp().nuxt2Context.error(errorData.value);
}

const breadcrumb = [
  {
    label: 'Urlaubs-Essentials',
    to: 'urlaubsessentials',
  },
];
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.holiday {
  &__breadcrumb {
    max-width: $grid-max;
    margin-inline: auto;
  }

  &__header {
    --card-container-justify: center;
    --card-container-content-flex: 0 0 auto;
    --card-bg-color: #f3e3d4;
    margin-bottom: 1rem;

    @include mq($mq-sm) {
      --card-container-height: 400px;
      --card-image-background-object-position: 70%;
      --card-image-position-left: -100%;
      --image-btlr: var(--card-radius);
      --image-bblr: var(--card-radius);

      :deep(.card__image) {
        z-index: 0;
      }
    }
  }

  &__offers {
    margin-bottom: $grid-base * 2;
  }
}
</style>
